<template>
  <ValidationObserver ref="validator" slim>
    <div class="lib__field" data-cy="identification-confirmation-component" v-if="eanInfoNotFound">
      <Feedback level="alert" outline simple icon>
        <p>{{ $t(`common.errors.ean.notFound`) }}</p>
      </Feedback>
    </div>
    <div class="lib__field" data-cy="identification-confirmation-component" v-else>
      <h3>{{ $t('common.identification.message') }}</h3>

      <ul class="lib__infobox-list">
        <InfoBox item level="primary">
          <template v-slot:icon>
            <img :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt="electricity" />
          </template>
          <template>
            <h3 class="lib__text-uppercase">{{ $t('common.identification.eanCode') }}</h3>
            <p>{{ eanCode }}</p>
          </template>
        </InfoBox>
        <InfoBox item level="success">
          <template v-slot:icon>
            <div class="lib__tooltips lib__tooltips--top-left">
              <span>
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <span class="lib__tooltips__data">{{ $t('common.identification.addressTooltip') }}</span>
            </div>
          </template>
          <template>
            <h3 class="lib__text-uppercase">{{ $t('common.identification.address') }}

            </h3>
            <p>{{ addressFromConsumption }} </p>
          </template>
        </InfoBox>
      </ul>

      <div class="lib__field__note">
        <div>
          <b v-html="$t('common.identification.wrongAddressMessage')"></b>
          <button class="lib__chat_trigger lib__btn lib__btn--primary lib__btn--small" @click="openChat"><i class="fas fa-comments"></i></button>
        </div>
      </div>

    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { GridAccessPoint } from '@/models'
import { chatService } from '@/services'

@Component
export default class IdentificationConfirmation extends Vue {
  //#region [Props]
  @Prop({ type: String, required: true }) public readonly eanCode!: string
  @Prop({ type: Object, required: false, default: null }) public readonly eanInfo!: GridAccessPoint | null
  //#endregion

  //#region [Data]
  //#endregion

  //#region [Computed]
  private get eanInfoNotFound(): boolean {
    return this.eanInfo == null;
  }

  private get addressFromConsumption() {
    if (this.eanInfo) {
      const address = this.eanInfo.consumptionAddress
      let str = address.streetName
      if (address.houseNumber) {
        str += ' ' + address.houseNumber
      }
      if (address.complement) {
        str += ' ' + address.complement
      }
      if (address.complementBox) {
        str += ' ' + address.complementBox
      }
      if (address.floorNumber) {
        str += ` (${this.$t(`common.identification.floor`).toString()}: ${address.floorNumber})`
      }
      str += ', ' + address.zipCode
      str += ' ' + address.cityName
      return str
    }
    return ''
  }
  //#endregion

  //#region [Method]
  private openChat() {
    chatService.openChat()
  }
  //#endregion
}
</script>


